export class UrlClassName {
    static readonly user = "user";
    static readonly poll = "poll";
    static readonly pollQuestionCollection = "poll-question-collection";
    static readonly pollImageCollection = "poll-image-collection";
    static readonly comment = "comment";
    static readonly pollVote = "poll-vote";
    static readonly result = "result";
    static readonly script = "script";
    static readonly category = "category";
    static readonly notification = "notification";
    static readonly appNotification = "app-notification";
    static readonly appNotificationImpression = "app-notification-impression";
    static readonly oneSignal = "one-signal";
    static readonly common = "common";
    static readonly s3File = "s3-file";
    static readonly auth = "auth";
    static readonly session = "session";
    static readonly firebase = "firebase";
    static readonly contact = "contact";
    static readonly inviteContact = "invite-contact";
    static readonly influencer = "influencer";
    static readonly interest = "interest";
    static readonly pollImpression = "poll-impression";
    static readonly geoIp = "geo-ip";
    static readonly msg91 = "msg91";
    static readonly webHook = "webhook";
    static readonly misc = "misc";
    static readonly intro = "intro";
    static readonly video = "video";
}

export class UrlActionName {
    //Crud
    static readonly get = "get";
    static readonly insert = "insert";
    static readonly fetch = "fetch";
    static readonly update = "update";
    static readonly upsert = "upsert";
    static readonly delete = "delete";
    // Other
    static readonly list = "list";
    static readonly track = "track";
    static readonly follow = "follow";
    static readonly unfollow = "unfollow";
    static readonly checkPhone = "checkPhone";
    static readonly block = "block";
    static readonly unblock = "unblock";
    static readonly report = "report";
}
